module.exports = __webpack_public_path__ + "img/intro_uk.65c048df.svg";